import {
  Flex,
  Text,
  Center,
  Drawer,
  DrawerBody,
  // DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  // Button,
  Box,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { differenceInDays } from 'date-fns'
import { Notes } from 'components/icons'
import { PATCH_NOTES } from './data'
import NoveltyBadge from './components/NoveltyBadge'
// import FilterContainer from './components/FilterContainer'
import NotesContainer from './components/NotesContainer'
import FilterContainer from './components/FilterContainer'

export default function PatchNotesButton({ setHaveNotification }: any) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [thereIsNews, setThereIsNews] = useState(false)

  useEffect(() => {
    for (let i = 0; i < PATCH_NOTES.length; i++) {
      const date = PATCH_NOTES[i].publicationDate || PATCH_NOTES[i].creationDate
      const _differenceInDays = differenceInDays(new Date(Date.now()), new Date(date))
      if (_differenceInDays <= 5) {
        setHaveNotification(true)
        setThereIsNews(true)
        return
      }
    }
  }, [])

  useEffect(() => {
    const date = '2025-11-13' // última nota
    const _differenceInDays = differenceInDays(new Date(Date.now()), new Date(date))
    if (_differenceInDays <= 5) {
      setHaveNotification(true)
      setThereIsNews(true)
      return
    }
  }, [])

  return (
    <>
      <Flex w="300px" p={2} justify="space-between" onClick={onOpen}>
        <Flex flexDir="column" justify="center" gap={1}>
          <Text fontSize="sm" fontWeight="bold">
            Notas de atualização
          </Text>
          <Text fontSize="xs">Veja a evolução da plataforma</Text>
          {thereIsNews && <NoveltyBadge />}
        </Flex>
        <Center w="80px">
          <Notes variant="twoTone" boxSize={14} />
        </Center>
      </Flex>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="full">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton size={'lg'} />
          <DrawerHeader>Notas de atualização</DrawerHeader>

          <DrawerBody p={0} bg="red">
            {/* <Flex w="full" h="100%" bg="bgContainer" display={['none', 'none', 'flex', 'flex', 'flex']}>
              <Box w="40%" h="100%" bg="bgContent" p={2}>
                <Calendar />
              </Box>
              <Box w="60%" h="100%">
                <NotesContainer />
              </Box>
            </Flex> */}

            <Flex w="full" h="100%" bg="bgContainer" display={['none', 'none', 'flex', 'flex', 'flex']}>
              <Box w="40%" h="100%" bg="bgContent">
                <FilterContainer />
              </Box>
              <Box w="60%" h="100%">
                <NotesContainer />
              </Box>
            </Flex>

            <Flex w="full" bg="bgContainer" display={['flex', 'flex', 'none', 'none', 'none']}>
              <Box w="100%">
                <NotesContainer />
              </Box>
            </Flex>
          </DrawerBody>
          {/* 
          <DrawerFooter>
            <Button onClick={onClose}>Concluir</Button>
          </DrawerFooter> */}
        </DrawerContent>
      </Drawer>
    </>
  )
}
